import { RatePlan } from "../pages/customerSettings/RatePlans";

export function displayWalletRates(basePlans: RatePlan[], country?: string) {
  return [
    ...basePlans,
    { id: "googlepay", label: "Google Pay" },
    { id: "applepay", label: "Apple Pay" },
    ...(process.env.REACT_APP_FF_DISPLAY_PAYPAL?.toLowerCase() === "true"
      ? [{ id: "paypal", label: "PayPal" }]
      : []),
  ];
}
